import { JSX, memo } from "react";

const styles = {
  main: "grid h-screen min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8",
  container: "text-center",
  code: "text-base font-semibold text-green-600 text-4xl sm:text-8xl",
  title: "mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl",
  description: "mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8",
  actions: "mt-10 flex items-center justify-center gap-x-6",
  link: "rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
};

const Error404 = (): JSX.Element => {
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <p className={styles.code}>404</p>
        <h1 className={styles.title}>
          Page not found
        </h1>
        <p className={styles.description}>
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className={styles.actions}>
          {/* <a
            href="/home"
            className={styles.link}
          >
            Go back
          </a> */}
        </div>
      </div>
    </main>
  );
};

export default memo(Error404);